<template>
    <div class="bizcomp-assets box">
        <my-assets-list v-if="$util.belongHx() && isbind" ref="assets"></my-assets-list>
        <template v-else-if="!$util.belongHx() && isbind">
            <el-tabs v-model="activeType" class="tab" v-on:tab-click="handleClick">
                <el-tab-pane name="assets" label="资产总览">
                    <my-assets ref="assets"></my-assets>
                </el-tab-pane>
                <!-- <el-tab-pane name="combination" label="组合投资">
                <combo-assets ref="comboAssets"></combo-assets>
                </el-tab-pane> -->
                <el-tab-pane name="collection" label="我的自选">
                    <my-collection ref="collection"></my-collection>
                </el-tab-pane>
            </el-tabs>
            <a
                v-show="activeType == 'assets'"
                class="file-button"
                :href="downLoadUrl"
                download="资产证明"
                target="_blank"
            >
                下载资产证明
            </a>
        </template>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import myAssets from "@/components/fund/myAssets";
import myAssetsList from "@/components/fund/myAssetsList";
// import comboAssets from "@/components/fund/comboAssets.vue";
import myCollection from "@/components/fund/myCollection";
import urls from "@/api/urls";
import commonApi from "@/api/common";
import cache from "@/assets/js/cache";

export default {
    name: "AssetTotal",
    components: {
        myAssets,
        myAssetsList,
        // comboAssets,
        myCollection
    },
    mixins: [mixin],
    data() {
        return {
            activeType: "assets", // tab类型
            downLoadUrl: "", // 下载资产证明url
            isbind: false // 是否绑定
        };
    },
    watch: {
        "$store.state.user.info": {
            handler() {
                this.belongToDialog();
            },
            deep: true
        }
    },
    async created() {
        this.belongToDialog();
        if (!this.$util.belongHx()) {
            if (this.$route.query && this.$route.query.tab) {
                this.activeType = this.$route.query.tab;
                this.$router.replace({ path: this.$route.path, query: {} });
            }
            this.downLoadUrl =
                this.$util.fileUploadPath(urls.assetsPdf) +
                "?token=" +
                this.$cache.getSessionToken();
            // 查询业务是否需要验证交易密码
            const res = await commonApi.queryValidPwdTrdMethod({
                acceptmethodstr: this.$util.getConfig().systemtype
            });
            const list = res.data || [];
            this.$cache.setValidPwdTrdList(list);
        }
    },
    methods: {
        handleClick() {
            if (this.activeType == "assets") {
                this.$refs.assets.searchAssets();
            } else if (this.activeType == "collection") {
                this.$refs.collection.searchFund();
            }
        },
        belongToDialog() {
            if (
                this.$store.state.user.info.isbind &&
                this.$store.state.user.info.isbind !== "1" &&
                this.$util.belongHx() &&
                !cache.getBinded() &&
                !sessionStorage.getItem("isopen")
            ) {
                sessionStorage.setItem("isopen", 1);
                this.$belongToDialog();
            }
            this.isbind = this.$cache.getBinded();
        }
    }
};
</script>

<style lang="scss">
@import "../../assets/css/varibles";
.box {
    background: #ffffff;
    border: 1px solid #f1f1f1;
    position: relative;
    margin-bottom: 20px;
    .tab {
        margin: 0 25px;
        .el-tabs__nav-wrap:after {
            background: #f1f1f1;
        }
        .el-tabs__nav-scroll {
            line-height: 70px;
            .el-tabs__active-bar {
                bottom: 5px;
                height: 3px;
                background: $color-a;
            }
            .el-tabs__item {
                font-size: $f20;
                font-weight: 400;
            }
            .el-tabs__item.is-active {
                font-weight: 500;
            }
        }
        .el-tabs__content {
            padding: 0 0 20px;
            .fund-offset .cell {
                padding: 0 10px 0 20px;
            }
            .fund-arr {
                padding: 0 20px;
                .cell {
                    padding: 0;
                }
            }
        }
    }
    .file-button {
        position: absolute;
        width: 100px;
        height: 40px;
        top: 15px;
        right: 25px;
        background: #f1f1f1;
        color: #666666;
        text-align: center;
        border-radius: 2px;
        font-size: 14px;
        line-height: 40px;
        cursor: pointer;
    }
}
</style>
